import {useMapContext} from '@/components/MindMap/index.mjs'
import ButtonCreateProduct from '@/biz/ButtonCreateProduct.jsx'
import _ToolBar from '../ToolBar.jsx'
import MenuButtonAi from './MenuButtonAi.jsx'
import MenuButtonAddToFrequentProject from '../menuButtons/MenuButtonAddToFrequentProject.jsx'
import MenuButtonDashboard from '../menuButtons/MenuButtonDashboard.jsx'
import MenuButtonEdit from '../menuButtons/MenuButtonEdit.jsx'
import MenuButtonInsertNode from '../menuButtons/MenuButtonInsertNode.jsx'
import MenuButtonInsertProducts from '../menuButtons/MenuButtonInsertProducts.jsx'
import MenuButtonSetAsCurrentProject from '../menuButtons/MenuButtonSetAsCurrentProject.jsx'
import MenuButtonCompare from './MenuButtonCompare.jsx'
import MenuButtonExportSpec from './MenuButtonExportSpec.jsx'
import MenuButtonIntegrate from './MenuButtonIntegrate.jsx'
import MenuButtonMap from './MenuButtonMap.jsx'
import MenuButtonMerge from './MenuButtonMerge.jsx'
import MenuButtonMore from './MenuButtonMore.jsx'
import MenuButtonProductList from './MenuButtonProductList.jsx'
import MenuButtonPublishMap from './MenuButtonPublishMap.jsx'
import MenuButtonReviseMap from './MenuButtonReviseMap.jsx'
import MenuButtonSaveMap from './MenuButtonSaveMap.jsx'
import MenuButtonUvDesigner from './MenuButtonUvDesigner.jsx'
import MenuButtonWfDesigner from './MenuButtonWfDesigner.jsx'

export default function ToolBar(props) {
    const map = useMapContext()
    const {mapTypeCode, prjId, prjTypeCode, subTypeCode, sVer} = map.data

    return (
        <_ToolBar {...props}>
            <div>
                <MenuButtonDashboard />
                <MenuButtonWfDesigner />
                <MenuButtonUvDesigner />
            </div>

            <div>
                <MenuButtonMap />
                <MenuButtonEdit />
                <MenuButtonInsertNode type="common" />
                <MenuButtonInsertNode type="concept" />
                <MenuButtonInsertNode type="product" />
                <MenuButtonInsertProducts />
                <MenuButtonSaveMap />
                <MenuButtonPublishMap />
                <MenuButtonReviseMap />
                <MenuButtonIntegrate />

                {
                    'SA_MAP' === mapTypeCode &&

                    <>

                        <MenuButtonProductList />

                        {false &&
                        <ButtonCreateProduct
                            prjId={prjId}
                            prjTypeCode={prjTypeCode}
                            subTypeCode={subTypeCode}
                            sVer={sVer}
                        >
                            新建制品
                        </ButtonCreateProduct>
                        }

                        <MenuButtonAi />
                    </>
                }

                <MenuButtonCompare />
                <MenuButtonMerge />
                <MenuButtonExportSpec />
                <MenuButtonMore />
            </div>

            <div>
                <MenuButtonSetAsCurrentProject />
                <MenuButtonAddToFrequentProject />
            </div>
        </_ToolBar>
    )
}
